"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MeasureTest_1 = __importDefault(require("./MeasureTest"));
var Logger_1 = __importDefault(require("../Logger"));
var DownloadTest = /** @class */ (function (_super) {
    __extends(DownloadTest, _super);
    function DownloadTest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'download';
        _this.length = 50000;
        _this.onTick = function (current) {
            var time = _this.passedTime;
            var _a = _this, timeLeft = _a.timeLeft, testTime = _a.testTime;
            // Speed in mbits
            var speed = current * 0.000008;
            // Count nr of parallel connections based on current speed.
            // Default to last nr of wanted connections
            var connections = _this.wantedConnections;
            // Calculated size to download based on
            // https://github.com/dotse/bredbandskollen/wiki/Websocket:-Server-API#nedladdning
            var size = _this.length;
            if (time > (testTime - 500)) {
                connections = 0;
                size = 0;
            }
            else {
                if (time < (testTime / 2)) {
                    if (speed >= 500.0) {
                        connections = 48;
                    }
                    else if (speed >= 250.0) {
                        connections = 32;
                    }
                    else if (speed >= 100.0) {
                        connections = 24;
                    }
                    else if (speed >= 50.0) {
                        connections = 12;
                    }
                    else {
                        connections = 4;
                    }
                }
                if (time < (testTime - 500)) {
                    var expectation = current * timeLeft;
                    var minSize = 6000;
                    var maxSize = 40000000;
                    size = Math.round(Math.max(minSize, Math.min(maxSize, expectation / 4 / connections)));
                }
            }
            _this.length = size;
            _this.setNoConnections(connections, true);
        };
        return _this;
    }
    DownloadTest.prototype.onStart = function () {
        _super.prototype.onStart.call(this);
        this.setNoConnections(10, true);
    };
    DownloadTest.prototype.handleOpen = function (id) {
        try {
            this.connections[id].download(this.length);
        }
        catch (error) {
            Logger_1.default.log(error);
        }
    };
    DownloadTest.prototype.handleMessage = function (id, e) {
        if (e.data instanceof ArrayBuffer) {
            this.loaded += e.data.byteLength;
        }
        var connection = this.connections[id];
        var testEndThreshold = this.testTime - 50;
        if (!this.length) {
            Logger_1.default.log('Ignore result from closing connections');
            return;
        }
        if (this.passedTime < testEndThreshold && this.length && connection.readyState() === 1) {
            try {
                this.connections[id].download(this.length);
            }
            catch (error) {
                // Failed to send message to websocket
                Logger_1.default.log('Failed to download', error);
                this.removeConnection(id);
            }
        }
        else {
            this.removeConnection(id);
        }
    };
    return DownloadTest;
}(MeasureTest_1.default));
exports.default = DownloadTest;
//# sourceMappingURL=DownloadTest.js.map